<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">客户会面记录</span>
      <span class="zn-text-grey">点击’完成填写‘，自动上传到公司附件，解析内容替换到对应字段</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div v-loading="submiting"
        element-loading-text="努力解析中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="zn-content-item-inline">
          <div class="zn-text-grey" style="width:65px"><span style="color:#f00">*</span>公司名称：</div>
          <el-select
            v-model="formData.公司名称"
            size="mini"
            placeholder="公司名称"
            filterable
            remote
            default-first-option
            :remote-method="searchCompanyName"
            @change="selectCompany"
            style="flex:1"
          >
            <el-option v-for="item in companies" :key="item._id" :label="item.label" :value="item.简称">
            </el-option>
          </el-select>
        </div>
        <div class="zn-content-item-inline">
          <div class="zn-text-grey" style="width:65px;">客户经理：</div>
          <el-select size="mini" v-model="formData.客户经理" filterable style="width:180px">
            <el-option v-for="(account, k) in accounts" :key="k" :label="account" :value="account"></el-option>
          </el-select>
          <div class="zn-text-grey" style="width:65px;margin-left:10px">会面时间：</div>
          <el-date-picker
            size="mini"
            v-model="formData.会面时间"
            type="date"
            value-format="yyyy.MM.dd"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="zn-content-item" v-for="(field, k) in fields" :key="k">
          <div class="zn-text-grey">{{ field.label }}：</div>
          <div v-if="field.children" style="padding-left:15px">
            <div class="zn-content-item" v-for="child in field.children" :key="child.value">
              <div class="zn-text-grey">{{ child.label }}：</div>
              <el-input
                type="textarea"
                :rows="2"
                :placeholder="child.placeholder"
                v-model="formData[child.value]">
              </el-input>
            </div>
          </div>
          <el-input
            v-else
            type="textarea"
            :rows="2"
            :placeholder="field.placeholder"
            v-model="formData[field.value]">
          </el-input>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="showComfirm"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="470px"
      class="radish-dia"
    >
      <div style="font-size:12px;color:#888;">
        点击替换全部，将把这份客户会面记录里的内容覆盖到公司对应字段并存为附件
      </div>
      <div style="display:flex;justify-content:center;padding:20px;">
        <div class="zn-template-btn" @click="submit" style="margin-right:10px">替换全部</div>
        <div class="zn-template-btn" @click="saveFile">只存为附件</div>
      </div>
    </el-dialog>
    <div v-if="company._id" class="zn-template-submit" @click="downloadFile" style="margin-left:-160px;">导出</div>
    <div v-if="company._id" class="zn-template-submit" @click="openCompany(company._id)">查看公司详情</div>
    <div v-if="company._id" class="zn-template-submit" @click="showComfirm=true" style="margin-left:60px;">完成填写</div>
  </div>
</template>
<script>
const dateFormat = require('dateformat');
import { download } from '../../../project/src/constant/utils'
export default {
  props: {
    componentName: String,
    item: Object,
  },
  data() {
    return {
      formData: {
        公司名称: '',
        客户经理: '',
        会面时间: '',
        一句话介绍: '',
        公司介绍: '',
        领军人物: '',
        公司亮点: '',
        业务特点风格资源来源: '',
        人员风格: '',
        公司劣势: '',
        公司文化: '',
        未来战略: '',
        公司架构: '',
        公司薪酬概况: '',
        公司痛点和HR的痛点: '',
        人才画像: '',
        历史人才来源: '',
        历史招聘量和猎头合作情况: '',
        今年招聘量和猎头预算: '',
        热招职位: '',
        面试流程: '',
        客户反向提问: '',
        八卦行业认知: '',
      },
      fields: [
        {
          label: '一句话介绍', value: '一句话介绍',
          placeholder: '最能体现该家公司价值的一句话'
        },
        {
          label: '公司介绍', value: '公司介绍',
          placeholder: '详情介绍',
        },
        {
          label: '领军人物', value: '领军人物',
          placeholder: '姓名+人物介绍',
        },
        {
          label: '公司亮点', value: '公司亮点',
          placeholder: '“ 猎头是向候选人传达公司形象的核心渠道，您觉得咱们公司有哪些核心优势需要我们来帮您传达 ”',
        },
        {
          label: '业务特点/风格/资源来源/业务对标公司', value: '业务特点风格资源来源',
          placeholder: '市场化；长期主义；正直等',
        },
        {
          label: '人员风格', value: '人员风格',
          placeholder: '人员风格',
        },
        {
          label: '公司劣势', value: '公司劣势',
          placeholder: '“ 近期我们有哪些看重候选人没谈成的情况，大概原因是什么？比如薪酬职级是否需要我们在前期做预期管理，或者是一些不好的市场传闻我们可以后期在市场上做一些辟谣 ”',
        },
        {
          label: '公司文化', value: '公司文化',
          placeholder: '公司文化',
        },
        {
          label: '未来战略', value: '未来战略',
          placeholder: '未来战略',
        },
        {
          label: '公司架构', value: '公司架构',
          placeholder: '公司架构',
        },
        {
          label: '公司薪酬概况', value: '公司薪酬概况',
          placeholder: '” 我们找这个岗位大概的固薪范围或者机制上大概是？ ”',
        },
        {
          label: '公司痛点和HR的痛点', value: '公司痛点和HR的痛点',
          placeholder: '',
        },
        {
          label: '人才画像', value: '人才画像',
          placeholder: '“ 我们对人才上面有什么特别的要求，比如说年龄，性别，学历背景，或者说过往比较倾向于哪些平台的人，然后软性上领导会有哪些偏好？ ”',
        },
        {
          label: '招聘情况',
          children: [
            { label: '1、合作回顾/成交记录', value: '历史人才来源' },
            { label: '2、历史招聘量和猎头合作情况', value: '历史招聘量和猎头合作情况' },
            { label: '3、今年招聘量和猎头预算', value: '今年招聘量和猎头预算' },
          ]
        },
        {
          label: '热招职位', value: '热招职位',
          placeholder: '',
        },
        {
          label: '面试流程', value: '面试流程',
          placeholder: '',
        },
        {
          label: '客户反向提问', value: '客户反向提问',
          placeholder: '',
        },
        {
          label: '八卦/行业认知', value: '八卦行业认知',
          placeholder: '',
        },

        // {
        //   label: '目标公司', value: '目标公司',
        //   placeholder: '客户看重什么公司的人',
        // },
        // {
        //   label: '招聘职位', value: '招聘职位',
        //   placeholder: '',
        // },
        // {
        //   label: 'Q&A客户问题准备', value: '客户问题准备',
        //   placeholder: '',
        // },
      ],
      fieldMap: {
        一句话介绍: '一句话简介',
        公司介绍: '公司介绍',
        公司文化: '公司文化',
        未来战略: '未来战略',
        公司架构: '公司架构',
        面试流程: '面试流程',
        领军人物: '领导介绍',
        公司亮点: '公司亮点.content',
        公司劣势: '公司劣势.content',
        人员风格: '人员风格',
        业务特点风格资源来源: '业务特点/风格/资源来源.content',
        人才画像: '人员整体情况',
        公司薪酬概况: '薪酬/职级/奖金机制',
        公司痛点和HR的痛点: '公司及HR痛点',
        历史人才来源: '历史人才来源',
        历史招聘量和猎头合作情况: '历史招聘量和猎头合作情况',
        今年招聘量和猎头预算: '今年招聘量和猎头预算',
      },
      coverFieldMap: {
        历史招聘量和猎头合作情况: '目前合作情况',
        今年招聘量和猎头预算: '目前合作情况',
        历史人才来源: '目前合作情况',
      },
      logFields: [
        '热招职位',
        '客户反向提问',
        '八卦行业认知'
      ],
      submiting: false,
      companies: [],
      company: {},
      showComfirm: false,
    }
  },
  computed: {
    accounts() {
      return app.accounts
    }
  },
  watch: {
    formData: {
      // 缓存到local
      handler: function(newVal) {
        localStorage.setItem(this.componentName, JSON.stringify(newVal))
        if (this.company._id) {
          localStorage.setItem(`${this.componentName}cid`, this.company._id)
        }
      },
      deep: true,
    },
  },
  methods: {
    async searchCompanyName(name) {
      try {
        name = name.replace(' ','')
        if (!name) return this.companies = []
        const res = await app.service('company').serchCompany(name)
        const sliceArr = res.data.slice(0, 10)
        const isClient = sliceArr.filter(v => v.公司阶段 === '已签约')
        const isNotClient = sliceArr.filter(v => v.公司阶段 !== '已签约')
        const arr = []
        if (isClient.length > 0) {
          const companies = isClient.map(val => {
            val.label = `${val.简称}${val.公司名称 ? '（'+val.公司名称+'）' : ''}${val.公司类型 ? '（'+val.公司类型+'）' : ''}${
              val.客户开发 ? '（'+val.客户开发+'）' : ''}`
            return val
          })
          arr.push(...companies)
        }
        if (isNotClient.length > 0) {
          const companies = isNotClient.map(val => {
            val.label = `${val.简称}${val.公司名称 ? '（'+val.公司名称+'）' : ''}（非客户）`
            return val
          })
          arr.push(...companies)
        }
        this.companies = window._.cloneDeep(arr)
      } catch (e) {
        console.error(e)
      }
    },
    async selectCompany(short) {
      const company = this.companies.find(c=>c.简称 == short)
      const res = await app.service('company').getCompany({ _id: company._id })
      if (res.status === 200) {
        this.company = res.result
        // 默认数据
        // const companyLeaders = await this.getCompanyLeaders(this.company._id)
        // const bulletins = await this.getCompanyBulletin(company.简称)
        // const showLeader = companyLeaders.splice(0,5).filter(a=>a).map(leader=>{
        //   return `${leader.姓名}${leader.部门?`/${leader.部门}`:''}${leader.职能模块&&leader.职能模块.length?`/${leader.职能模块.join('、')}`:''} ${leader.简介?`\n${leader.简介}`:''}\n\n`
        // })
        // const leaderStr = showLeader.join('').replace(/\n\n$/,'') || ''
        // const bulletinStr = bulletins.map(bulletin=>{
        //   return `${bulletin.标题}${bulletin.时间?`（${dateFormat(bulletin.时间,'yyyy.mm.dd')}）`:''}${bulletin.详情?`\n${bulletin.详情}`:''}\n\n`
        // }).join('').replace(/\n\n$/,'') || ''
        this.$set(this.formData, '客户经理', company.客户开发)
        this.$set(this.formData, '领军人物', company.领导介绍)
        // this.$set(this.formData, '八卦行业认知', bulletinStr)
        Object.keys(this.fieldMap).forEach(k => {
          const field = this.fieldMap[k]
          let comVal = ''
          if (field.indexOf('.') != -1) {
            const arr = field.split('.')
            if (this.company[arr[0]]) {
              comVal = this.company[arr[0]][arr[1]]
            }
          } else {
            comVal = this.company[field]
          }
          this.$set(this.formData, k, comVal)
        });
      } else {
        this.company = {}
      }
      // console.log(short, company)
    },
    async submit() {
      try {
        this.showComfirm = false
        if (this.submiting) return this.$message('正在解析中，请稍候')
        if (!this.formData.公司名称) return this.$message('请选择公司')
        if (!this.company._id) return this.$message('没有获取到公司数据')
        this.submiting = true
        // 更新公司数据
        const dt = {}
        Object.keys(this.fieldMap).forEach(k => {
          const field = this.fieldMap[k]
          const formVal = this.formData[k]
          let comVal = ''
          if (field.indexOf('.') != -1) {
            const arr = field.split('.')
            if (this.company[arr[0]] && typeof this.company[arr[0]] == 'object') {
              comVal = this.company[arr[0]][arr[1]]
              if (formVal) {
                dt[field] = formVal
              }
            } else {
              if (formVal) {
                dt[arr[0]] = {}
                dt[arr[0]][arr[1]] = formVal
              }
            }
          } else {
            comVal = this.company[field]
            if (comVal && !dt[field]) {
              dt[field] = comVal
            }
            if (formVal) {
              dt[field] = formVal
            }
          }
        });
        Object.keys(this.coverFieldMap).forEach(k => {
          const field = this.coverFieldMap[k]
          const comVal = this.company[field]
          const formVal = this.formData[k]
          if (comVal && !dt[field]) {
            dt[field] = comVal
          }
          if (formVal) {
            if (!dt[field]) {
              dt[field] = formVal
            } else {
              dt[field] += ('\n'+formVal)
            }
          }
        });
        // return // console.log(this.company, this.formData, dt)
        const resCom = await app.service('company').modifyCompany({
          query: { _id: this.company._id },
          data: dt,
        })
        if (resCom.status !== 200){
          console.error(resCom.msg)
        }
        let content = ''
        this.logFields.forEach(field => {
          const formVal = this.formData[field]
          if (formVal) {
            content += field+':'+formVal+';\n'
          }
        });
        const option = {
          cid: this.company._id,
          remark: { user: app.user.account, content },
          type: '沟通备注',
        }
        const remarkRes = await app.service('company').addCompanyRemark(option)
        if (remarkRes.status !== 'success') {
          console.error(remarkRes.msg)
        }
        this.submiting = false
        await this.saveFile()
      } catch (e) {
        console.error(e)
      }
    },
    async saveFile() {
      try {
        this.showComfirm = false
        if (this.submiting) return this.$message('正在解析中，请稍候')
        if (!this.formData.公司名称) return this.$message('请选择公司')
        if (!this.company._id) return this.$message('没有获取到公司数据')
        this.submiting = true
        // 上传文件
        const t = this.formData.会面时间 ? this.formData.会面时间.replaceAll(/\./g,''): dateFormat(new Date(), 'yyyymmdd')
        const item = {
          fileName: `阿尔法-客户会面记录-${this.formData.公司名称||''}-${t}.doc`,
          type: '客户会面记录',
          form: this.formData,
        }
        const res = await app.service('file').generateAppointmentByType(item)
        if (res.status == 'success') {
          const file = res.data
          try {
            const option = {
              createdAt: new Date().getTime(),
              fileId: file._id,
              md5: file.md5,
              uploader: file.uploader,
              originalname: file.originalname,
              src: file.src,
              type: '客户会面',
              companyId: this.company._id,
            }
            const insertRes = await app.service('company').insertCompanyAtta(option)
            if (insertRes.status == 'success') {
              this.$emit('closeTpl', {msg: '小阿已为您解析并上传完毕', other: {msgType:'new', cid: this.company._id, 简称: this.company.简称}})
            } else {
              this.$message.error(insertRes.msg)
            }
          } catch (e) {
            this.$message.error(e.message)
          }
          localStorage.removeItem(this.componentName)
          localStorage.removeItem(`${this.componentName}cid`)
        }
        this.submiting = false
      } catch (error) {
        console.error(e)
      }
    },
    async downloadFile() {
      this.showComfirm = false
      if (this.submiting) return this.$message('正在解析中，请稍候')
      this.submiting = true
      // 上传文件
      const t = this.formData.会面时间 ? this.formData.会面时间.replaceAll(/\./g,''): dateFormat(new Date(), 'yyyymmdd')
      const item = {
        fileName: `阿尔法-客户会面记录-${this.formData.公司名称||'模板'}-${t}.doc`,
        type: '客户会面记录',
        form: this.formData,
      }
      const res = await app.service('file').generateAppointmentByType(item)
      if (res.status == 'success') {
        const file = res.data
        download({md5: res.data.md5})
      }
      this.submiting = false
    },
    openCompany(cid) {
      window.open(`${window.frontend}/#/company/${cid}`)
    },
    async getCompanyLeaders(cid) {
      if (!cid) return []
      const res = await app.service('company').getCompanyLeadersV2({cid})
      if (res.status === 'success') {
        return res.data
      } else {
        return []
      }
    },
    async getCompanyBulletin(name) {
      if (!name) return []
      const res = await app.service('misc').listBulletinsSample({ query: {type: "transfer", 公司: name} })
      if (res.status === 'success') {
        const arr = res.data && res.data.data || []
        arr.sort((a,b)=>b.modifiedTimestamp - a.modifiedTimestamp)
        return arr.splice(0,5)
      } else {
        return []
      }
    },
    async initData(defaultForm) {
      if (defaultForm) {
        this.formData = defaultForm
        const cid = localStorage[`${this.componentName}cid`] || this.item.cid
        if (cid) {
          const res = await app.service('company').getCompany({ _id: cid })
          if (res.status === 200) {
            const company = res.result
            company.label = `${company.简称}${company.公司名称 ? '（'+company.公司名称+'）' : ''}${company.公司类型 ? '（'+company.公司类型+'）' : ''}${
              company.客户开发 ? '（'+company.客户开发+'）' : ''}`
            this.company = company
          }
        }
      } else if (this.item.cid) {
        const res = await app.service('company').getCompany({ _id: this.item.cid })
        if (res.status === 200) {
          const company = res.result
          company.label = `${company.简称}${company.公司名称 ? '（'+company.公司名称+'）' : ''}${company.公司类型 ? '（'+company.公司类型+'）' : ''}${
            company.客户开发 ? '（'+company.客户开发+'）' : ''}`
          this.company = company
          // const companyLeaders = await this.getCompanyLeaders(this.item.cid)
          // const bulletins = await this.getCompanyBulletin(company.简称)
          // const showLeader = companyLeaders.splice(0,5).filter(a=>a).map(leader=>{
          //   return `${leader.姓名}${leader.部门?`/${leader.部门}`:''}${leader.职能模块&&leader.职能模块.length?`/${leader.职能模块.join('、')}`:''} ${leader.简介?`\n${leader.简介}`:''}\n\n`
          // })
          // const leaderStr = showLeader.join('').replace(/\n\n$/,'') || ''
          // const bulletinStr = bulletins.map(bulletin=>{
          //   return `${bulletin.标题}${bulletin.时间?`（${dateFormat(bulletin.时间,'yyyy.mm.dd')}）`:''}${bulletin.详情?`\n${bulletin.详情}`:''}\n\n`
          // }).join('').replace(/\n\n$/,'') || ''
          this.$set(this.formData, '公司名称', company.简称)
          this.$set(this.formData, '客户经理', company.客户开发)
          this.$set(this.formData, '领军人物', company.领导介绍)
          // this.$set(this.formData, '领军人物', leaderStr)
          // this.$set(this.formData, '八卦行业认知', bulletinStr)
          Object.keys(this.fieldMap).forEach(k => {
            const field = this.fieldMap[k]
            let comVal = ''
            if (field.indexOf('.') != -1) {
              const arr = field.split('.')
              if (this.company[arr[0]]) {
                comVal = this.company[arr[0]][arr[1]]
              }
            } else {
              comVal = this.company[field]
            }
            this.$set(this.formData, k, comVal)
          });
          if (this.item.autoDownload) {
            await this.downloadFile()
            this.$emit('closeTpl', {msg: '小阿已为您下载文件到左下角' })
          }
        } else {
          this.company = {}
        }
      } else {
        this.formData = {
          公司名称: '',
          客户经理: '',
          会面时间: '',
          一句话介绍: '',
          公司介绍: '',
          领军人物: '',
          公司亮点: '',
          业务特点风格资源来源: '',
          人员风格: '',
          公司劣势: '',
          公司文化: '',
          未来战略: '',
          公司架构: '',
          公司薪酬概况: '',
          公司痛点和HR的痛点: '',
          人才画像: '',
          历史人才来源: '',
          历史招聘量和猎头合作情况: '',
          今年招聘量和猎头预算: '',
          热招职位: '',
          面试流程: '',
          客户反向提问: '',
          八卦行业认知: '',
        }
      }
    }
  }
}
</script>
